import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { TimezoneChangePage } from './timezone-change';
import { TextMaskModule } from 'angular2-text-mask';
import { DirectivesModule } from '../../../directives/directives.module';
import { FoundationModule } from '../../../_foundation/foundation.module';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [
    TimezoneChangePage,
  ],
  imports: [
    IonicPageModule.forChild(TimezoneChangePage),
    TextMaskModule,
    DirectivesModule,
    FoundationModule,
    SharedModule,
  ],
})
export class TimezoneChangePageModule {
}



// WEBPACK FOOTER //
// ./src/pages/setup/timezone-change/timezone-change.module.ts